module.exports = __webpack_public_path__ + "img/1A-Ghost2.e61dac16.png";